export const stateName = 'userStats' as const
